'use client';

import config from '@/config';
import { ArrowRight } from 'lucide-react';
import mixpanel from 'mixpanel-browser';

// Templated bottom-of-post CTA rendered on every blog article.
export default function PostCTA() {
  return (
    <section className="relative overflow-hidden bg-ink-900 text-paper-50">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, #FDFAF3 1px, transparent 0)',
          backgroundSize: '22px 22px',
        }}
      />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 py-16 lg:py-20 text-center">
        <p className="font-hand text-brand-300 text-2xl mb-3 -rotate-2 inline-block">
          while you&apos;re here
        </p>
        <h2 className="font-display font-black text-3xl md:text-4xl tracking-[-0.02em] leading-[1.05]">
          Turn your next quiz{' '}
          <span className="italic font-medium text-brand-300">
            into a race.
          </span>
        </h2>
        <p className="mt-4 font-display text-paper-50/80 leading-relaxed max-w-lg mx-auto">
          QuizWhizzer plays your questions out on a game board. Students join
          with a code from any browser, no accounts needed.
        </p>
        <div className="mt-8">
          <a
            className="btn btn-primary rounded-full px-8 text-white shrink-button btn-letterpress"
            href={`${config.appUrl}/register`}
            onClick={() =>
              mixpanel.track('blog_cta_clicked', { location: 'post_footer' })
            }
          >
            Try it free
            <ArrowRight className="w-4 h-4" />
          </a>
          <p className="font-display text-paper-50/55 text-sm mt-4">
            Free to use &middot; no credit card
          </p>
        </div>
      </div>
    </section>
  );
}
